import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

export default function AlianzaLeCosy() {
  return (
    <Box
      sx={{
        backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1749058592/ebm/Rectangle_34625846_1_sgruqi.png)',
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        backgroundRepeat: 'no-repeat', 
        py: { xs: 4, md: 6 },
        px: { xs: 2, sm: 4, md: 10 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="space-between"
        sx={{ maxWidth: '1400px' }}
      >
        {/* Imagen laptop + celular */}
        <Grid
          item
          xs={12}
          md={5}
          order={{ xs: 2, md: 1 }}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-end' },
            alignItems: 'center',
            mt: { xs: 4, md: 0 },
            pr: { md: 0 },
          }}
        >
          <Box
            component="img"
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193157/ebm/alianzaLecosy_gjybqe.png"
            alt="Dispositivos mostrando sistema"
            sx={{
              width: '100%',
              maxWidth: { xs: '300px', sm: '350px', md: '400px' },
              objectFit: 'contain',
            }}
          />
        </Grid>

        {/* Texto + logo Lecosy (alineados inline) */}
        <Grid
          item
          xs={12}
          md={7}
          order={{ xs: 1, md: 2 }}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
            alignItems: 'center',
            mt: { xs: 0, md: 0 },
            pl: { xs: 0, md: 0 },
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: { xs: '100%', md: '454px' },
              textAlign: { xs: 'center', md: 'left' },
              display: 'flex',
              flexDirection: 'column',
              marginLeft: { md: '-40px' },
              px: { xs: 2, sm: 0 },
            }}
          >
            {/* Título con logo al lado de "Alianza" */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'center', md: 'flex-start' },
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1, sm: 0 },
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: { xs: '24px', sm: '28px', md: '32px' },
                  color: '#38383D',
                  fontWeight: 400,
                  whiteSpace: { xs: 'normal', sm: 'nowrap' },
                  lineHeight: 1.2,
                }}
              >
                Te presentamos nuestra alianza
                
              </Typography>
              <a href="https://www.lecosy.com.mx/" target="_blank" rel="noopener noreferrer">
                <Box
                  component="img"
                  src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193092/ebm/lecosyLogo_gnja7v.png"
                  alt="Logo Lecosy"
                  sx={{
                    width: { xs: '120px', sm: '140px', md: '150.97px' },
                    height: 'auto',
                    objectFit: 'contain',
                    ml: { xs: 0, sm: 1 },
                    cursor: 'pointer',
                    position: 'relative',
                    top: { xs: '3px', sm: '4px', md: '6px' },
                  }}
                />
              </a>
            </Box>

            {/* Descripción */}
            <Typography
              sx={{
                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                color: '#38383D',
                fontFamily: 'Poppins, sans-serif',
                whiteSpace: { xs: 'normal', sm: 'nowrap' },
                mt: { xs: 1, sm: 0 },
                 marginLeft: '35px',
                
              }}
            >
              Gestión automatizada de la estructura de Gobierno Corporativo.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}